import type { AsyncSequence } from "../types/AsyncSequence"

export const StreamCreate = (
  body: AsyncSequence<Uint8Array>,
  cancel?: () => void
): ReadableStream =>
  new ReadableStream({
    async start(controller) {
      for await (const bytes of body) controller.enqueue(bytes)
      controller.close()
    },
    cancel,
  })
